import React from 'react'
import { Spin } from 'antd'
import styled from 'styled-components'
import * as PropTypes from 'prop-types'

const StyledDashboardContainer = styled.div`
  text-align: center;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  &.auth {
    background: var(--main-gradient);
    .ant-spin-dot-item {
      background: #fff;
    }
  }
`

const DashboardLoader = ({ className }) => {
  return (
    <StyledDashboardContainer className={className}>
      <Spin size="large" />
    </StyledDashboardContainer>
  )
}

DashboardLoader.propTypes = {
  className: PropTypes.string
}

export default DashboardLoader
